/* eslint-disable import/no-cycle */
import {
    CustomItemRendererType,
    CustomItemRenderFieldProps,
    ExtandedFormContext,
    visibilityType,
} from '@europrocurement/flexy-form';
import { Box, Typography } from '@mui/material';
import React from 'react';

import { PercentWidget } from '@europrocurement/flexy-components';

import DirigeantPPView from './DirigeantPPView/DirigeantPPView';
import BeneficiaireView from './BeneficiaireView/BeneficiaireView';
import DirigeantPMView from './DirigeantPMView/DirigeantPMView';
import { EntreprisesIntervenantView } from './EntreprisesIntervenantView/EntreprisesIntervenantView';
import { NomsDeDomaineView } from './NomsDeDomaine/NomsDeDomaineView';
import { ActiviteView } from './Activite/ActiviteView';
import { GestionNDDView } from './GestionNDDView/GestionNDDView';
import CategoriesActivites from './CategoriesActivites/CategoriesActivites';
import SirenRne from './SirenRne/SirenRne';
import { GestionEtablissementView } from './GestionEtablissementView/GestionEtablissementView';
import { GestionDirigeantView } from './GestionDirigeantView/GestionDirigeantView';

export type customItemJsonProps = {
    formContext: ExtandedFormContext;
    props: CustomItemRenderFieldProps;
    legalForm?: string;
    mode?: string;
    visibility?: visibilityType;
};

export const customItemRenderer: CustomItemRendererType = (
    formContext: ExtandedFormContext,
    props: CustomItemRenderFieldProps,
    visibility: visibilityType,
) => {
    let display = true;
    let disabled = false;

    if (props.display === false) {
        display = false;
    } else if (typeof props.display === 'function') {
        display = props.display(formContext);
    }

    if (display === false) {
        return null;
    }

    if (props.disabled === true) {
        disabled = true;
    } else if (props.disabled) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        disabled = props.disabled(formContext);
    }

    switch (props.name) {
        case 'dirigeants_pp_sarl':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SARL"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pm_sarl':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SARL"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pp_sas':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SAS"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pm_sas':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SAS"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pp_sci':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SCI"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pm_sci':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SCI"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pp_scs':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SCI"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pm_scs':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SCI"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pp_snc':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SCI"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pm_snc':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SCI"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pp_sa':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SA"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pm_sa':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SA"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pp_gie':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="GIE"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pm_gie':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="GIE"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pp_sca':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SCA"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pm_sca':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SCA"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pp_scp':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SCP"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pm_scp':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SCP"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pp_agricole':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="AGRICOLE"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pm_agricole':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="AGRICOLE"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pp_societe_etrangere':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="SOCIETE_ETRANGERE"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pm_societe_etrangere':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="SOCIETE_ETRANGERE"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pp_liquidateur':
            return (
                <DirigeantPPView
                    formContext={formContext}
                    props={props}
                    legalForm="LIQUIDATEUR"
                    visibility={visibility}
                />
            );

        case 'dirigeants_pm_liquidateur':
            return (
                <DirigeantPMView
                    formContext={formContext}
                    props={props}
                    legalForm="LIQUIDATEUR"
                    visibility={visibility}
                />
            );

        case 'beneficiaires_effectif':
            return (
                <BeneficiaireView
                    formContext={formContext}
                    props={props}
                    visibility={visibility}
                />
            );

        case 'entreprises_intervenant':
            return (
                <EntreprisesIntervenantView
                    formContext={formContext}
                    props={props}
                    visibility={visibility}
                />
            );

        case 'noms_de_domaine':
            return (
                <NomsDeDomaineView
                    formContext={formContext}
                    props={props}
                    visibility={visibility}
                />
            );

        case 'activite':
            return (
                <ActiviteView
                    formContext={formContext}
                    props={props}
                    visibility={visibility}
                />
            );

        case 'gestion_ndd':
            return (
                <GestionNDDView
                    formContext={formContext}
                    props={props}
                    visibility={visibility}
                />
            );

        case 'siren_rne':
            return (
                <SirenRne
                    formContext={formContext}
                    props={props}
                    visibility={visibility}
                />
            );

        case 'gestion_fermeture_etablissement':
            return (
                <GestionEtablissementView
                    formContext={formContext}
                    props={props}
                    mode="fermeture"
                    visibility={visibility}
                />
            );

        case 'gestion_modification_identite_etablissement':
            return (
                <GestionEtablissementView
                    formContext={formContext}
                    props={props}
                    mode="modificationIdentite"
                    visibility={visibility}
                />
            );

        case 'gestion_dirigeant':
            return (
                <GestionDirigeantView
                    formContext={formContext}
                    props={props}
                    mode="modification"
                    visibility={visibility}
                />
            );

        case 'gestion_dirigeant_adresse':
            return (
                <GestionDirigeantView
                    formContext={formContext}
                    props={{ ...props, name: 'gestion_dirigeant' }}
                    mode="adresse"
                    visibility={visibility}
                />
            );

        case 'total_detention_directe_capital':
        case 'total_detention_indirecte_capital':
        case 'total_detention_directe_vote':
        case 'total_detention_indirecte_vote': {
            const values = [];
            if (props.rules?.renderTotalDetention) {
                for (let i = 0; i < props.rules?.renderTotalDetention?.length; i++) {
                    const valueWatched = formContext.watch(
                        props.rules.renderTotalDetention[i] as string,
                    );
                    values.push(parseFloat(valueWatched === '' ? 0 : valueWatched));
                }
            }
            return (
                <Box sx={{ margin: '25px 0' }}>
                    <PercentWidget
                        label={props.inputlabel as string}
                        values={values}
                    />
                </Box>
            );
        }

        case 'categories_activites':
            return (
                <CategoriesActivites
                    formContext={formContext}
                    props={props}
                />
            );

        default:
            return (
                <Typography variant="l2dh7">
                    Impossible d&apos;afficher le customItem le type type {props.name} n&apos;est
                    pas pris en charge
                </Typography>
            );
    }
};
